export class OrgUnit {
    id: string;
    name: string;
    code: string;
    nameCode: string;
    reassessmentFrequency: number;
    address1: string;
    address2: string;
    city: string;
    zip: string;
    state: string;
    children: Array<OrgUnit> = [];
    parents: Array<OrgUnit> = [];
    tagsCodes: Array<string> = [];

    constructor(orgUnit: any) {
        if (orgUnit) {
            this.id = orgUnit.id;
            this.name = orgUnit.name;
            this.code = orgUnit.code;
            this.nameCode = orgUnit.nameCode;
            this.reassessmentFrequency = orgUnit.reassessmentFrequency;
            this.address1 = orgUnit.address1;
            this.address2 = orgUnit.address2;
            this.city = orgUnit.city;
            this.zip = orgUnit.zip;
            this.state = orgUnit.state;
            if (orgUnit.children) {
                orgUnit.children.forEach((orgUnit) => {
                    this.children.push(new OrgUnit(orgUnit));
                });
            }
            if (orgUnit.parents) {
                orgUnit.parents.forEach((orgUnit) => {
                    this.parents.push(new OrgUnit(orgUnit));
                });
            }
            if (orgUnit.tagsCodes) {
                orgUnit.tagsCodes.forEach((code) => {
                    this.tagsCodes.push(code);
                })
            }
        }
    }
}